import { FC, useContext, useState } from "react";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useDueDatesApi } from "../../http/dueDates/api";
import ModalDialog from "../ui/ModalDialog";

type DeleteDueDateDialogProps = {
  dueDateId: string;
  carId: string;
  onClose: (success?: boolean) => void;
};

const DeleteDueDateDialog: FC<DeleteDueDateDialogProps> = ({ dueDateId, carId, onClose }) => {
  const i18n = useI18n();
  const dispatch = useContext(NotificationDispatch);
  const dueDatesApi = useDueDatesApi();
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <ModalDialog
      onClose={onClose}
      title={i18n.t.dueDates.delete}
      isSubmitting={isSubmitting}
      actions={[
        {
          title: i18n.t.common.cancel,
          type: "secondary",
          onClick: onClose,
        },
        {
          title: i18n.t.common.yes,
          onClick: () => {
            setIsSubmitting(true);
            dueDatesApi
              .deleteAdminDueDate(dueDateId, carId)
              .catch((err) => dispatch(showErrorNotification(i18n, err)))
              .then(() => {
                onClose(true);
                dispatch(showSuccessNotification(i18n.t));
              })
              .finally(() => setIsSubmitting(false));
          },
        },
      ]}
    >
      {i18n.t.dueDates.questions.delete}
    </ModalDialog>
  );
};

export default DeleteDueDateDialog;
